import GateKeeperMiddleware from '@/middleware/GateKeeperMiddleware.js';

export default [
    {
        path: '/ebooks/access-denied',
        name: 'ebook-access-denied',
        component: () => import('@/components/ebook/EbookAccessDenied.vue'),
        meta: {
            title: 'Ebook Access Denied',
        },
    },
    {
        path: '/ebooks',
        component: () => import('@/pages/ebooks/EbookIndex.vue'),
        props: true,
        children: [
            {
                name: 'ebooks-index',
                path: '',
                component: () => import('@/components/ebooks/EbooksView.vue'),
                meta: {
                    title: 'Ebooks',
                    middleware: [GateKeeperMiddleware],
                    ability: { action: 'viewAny', subject: 'Ebook' },
                },
                props: true,
            },
        ],
    },
];
